var map = {
	"./de.png": "72fe",
	"./eng.png": "2e72",
	"./fr.png": "26fc",
	"./hin.png": "4b171",
	"./kan.png": "eb8f",
	"./mal.png": "6abe",
	"./pt.png": "5e3c",
	"./tam.png": "5c38",
	"./tel.png": "7d82"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c99";